"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgBond = void 0;
/* eslint-disable */
var long_1 = __importDefault(require("long"));
var minimal_1 = __importDefault(require("protobufjs/minimal"));
var common_1 = require("../../../../../thorchain/v1/common/common");
function createBaseMsgBond() {
    return {
        txIn: undefined,
        nodeAddress: new Uint8Array(),
        bond: "",
        bondAddress: "",
        signer: new Uint8Array(),
        bondProviderAddress: new Uint8Array(),
    };
}
exports.MsgBond = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.default.Writer.create(); }
        if (message.txIn !== undefined) {
            common_1.Tx.encode(message.txIn, writer.uint32(10).fork()).ldelim();
        }
        if (message.nodeAddress.length !== 0) {
            writer.uint32(18).bytes(message.nodeAddress);
        }
        if (message.bond !== "") {
            writer.uint32(26).string(message.bond);
        }
        if (message.bondAddress !== "") {
            writer.uint32(34).string(message.bondAddress);
        }
        if (message.signer.length !== 0) {
            writer.uint32(42).bytes(message.signer);
        }
        if (message.bondProviderAddress.length !== 0) {
            writer.uint32(50).bytes(message.bondProviderAddress);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgBond();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.txIn = common_1.Tx.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.nodeAddress = reader.bytes();
                    break;
                case 3:
                    message.bond = reader.string();
                    break;
                case 4:
                    message.bondAddress = reader.string();
                    break;
                case 5:
                    message.signer = reader.bytes();
                    break;
                case 6:
                    message.bondProviderAddress = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        return {
            txIn: isSet(object.txIn) ? common_1.Tx.fromJSON(object.txIn) : undefined,
            nodeAddress: isSet(object.nodeAddress)
                ? bytesFromBase64(object.nodeAddress)
                : new Uint8Array(),
            bond: isSet(object.bond) ? String(object.bond) : "",
            bondAddress: isSet(object.bondAddress) ? String(object.bondAddress) : "",
            signer: isSet(object.signer)
                ? bytesFromBase64(object.signer)
                : new Uint8Array(),
            bondProviderAddress: isSet(object.bondProviderAddress)
                ? bytesFromBase64(object.bondProviderAddress)
                : new Uint8Array(),
        };
    },
    toJSON: function (message) {
        var obj = {};
        message.txIn !== undefined &&
            (obj.txIn = message.txIn ? common_1.Tx.toJSON(message.txIn) : undefined);
        message.nodeAddress !== undefined &&
            (obj.nodeAddress = base64FromBytes(message.nodeAddress !== undefined
                ? message.nodeAddress
                : new Uint8Array()));
        message.bond !== undefined && (obj.bond = message.bond);
        message.bondAddress !== undefined &&
            (obj.bondAddress = message.bondAddress);
        message.signer !== undefined &&
            (obj.signer = base64FromBytes(message.signer !== undefined ? message.signer : new Uint8Array()));
        message.bondProviderAddress !== undefined &&
            (obj.bondProviderAddress = base64FromBytes(message.bondProviderAddress !== undefined
                ? message.bondProviderAddress
                : new Uint8Array()));
        return obj;
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e;
        var message = createBaseMsgBond();
        message.txIn =
            object.txIn !== undefined && object.txIn !== null
                ? common_1.Tx.fromPartial(object.txIn)
                : undefined;
        message.nodeAddress = (_a = object.nodeAddress) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.bond = (_b = object.bond) !== null && _b !== void 0 ? _b : "";
        message.bondAddress = (_c = object.bondAddress) !== null && _c !== void 0 ? _c : "";
        message.signer = (_d = object.signer) !== null && _d !== void 0 ? _d : new Uint8Array();
        message.bondProviderAddress =
            (_e = object.bondProviderAddress) !== null && _e !== void 0 ? _e : new Uint8Array();
        return message;
    },
};
var globalThis = (function () {
    if (typeof globalThis !== "undefined")
        return globalThis;
    if (typeof self !== "undefined")
        return self;
    if (typeof window !== "undefined")
        return window;
    if (typeof global !== "undefined")
        return global;
    throw "Unable to locate global object";
})();
var atob = globalThis.atob ||
    (function (b64) { return globalThis.Buffer.from(b64, "base64").toString("binary"); });
function bytesFromBase64(b64) {
    var bin = atob(b64);
    var arr = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; ++i) {
        arr[i] = bin.charCodeAt(i);
    }
    return arr;
}
var btoa = globalThis.btoa ||
    (function (bin) { return globalThis.Buffer.from(bin, "binary").toString("base64"); });
function base64FromBytes(arr) {
    var e_1, _a;
    var bin = [];
    try {
        for (var arr_1 = __values(arr), arr_1_1 = arr_1.next(); !arr_1_1.done; arr_1_1 = arr_1.next()) {
            var byte = arr_1_1.value;
            bin.push(String.fromCharCode(byte));
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (arr_1_1 && !arr_1_1.done && (_a = arr_1.return)) _a.call(arr_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return btoa(bin.join(""));
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
